import React from 'react';

export function DrillCruxStat({
  value,
  label,
  delta,
  deltaGood,
  tone,
}: {
  value: React.ReactNode;
  label: string;
  delta?: string | null;
  deltaGood?: boolean;
  tone?: string;
}) {
  return (
    <div className="dcrux-stat">
      <div className="dcrux-stat-v" style={tone ? { color: tone } : undefined}>
        {value}
      </div>
      <div className="dcrux-stat-l">{label}</div>
      {delta != null && delta !== '' && (
        <div
          className="dcrux-stat-d"
          style={{
            color:
              deltaGood == null
                ? 'var(--ink-3)'
                : deltaGood
                  ? 'var(--st-steady)'
                  : 'var(--st-alert)',
          }}
        >
          {delta}
        </div>
      )}
    </div>
  );
}
